import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { IWorkqueueContextValue } from '../../shared/interfaces/WorkQueue';


export interface IWorkqueueContextSet {
  workqueueValue: IWorkqueueContextValue; 
  setWorkqueueValue: Dispatch<SetStateAction<IWorkqueueContextValue>>;
}

// Create the context with an initial value
export const WorkqueueContext = createContext<IWorkqueueContextSet | undefined>(undefined);

export const useWorkqueueContext = () => {
  const context = useContext(WorkqueueContext);
  if (!context) {
    throw new Error('useWorkqueueContext must be used within an WorkqueueContextProvider');
  }
  return context;
};


